import { graphql, readInlineData } from "react-relay";

import type { helpersCheckHasSeriesShortLabelContent$key } from "scmp-app/queries/__generated__/helpersCheckHasSeriesShortLabelContent.graphql";

export const checkHasSeriesShortLabel = (
  reference_: helpersCheckHasSeriesShortLabelContent$key,
) => {
  const data = readInlineData(
    graphql`
      fragment helpersCheckHasSeriesShortLabelContent on Content @inline {
        ... on Article {
          seriesShortLabel
          seriesContainer {
            seriesShortLabel
          }
        }
      }
    `,
    reference_,
  );

  return !!data.seriesContainer?.seriesShortLabel || !!data.seriesShortLabel;
};
